import { render, staticRenderFns } from "./PendingIncomeFromSale.vue?vue&type=template&id=9ab51bda&scoped=true"
import script from "./PendingIncomeFromSale.vue?vue&type=script&lang=js"
export * from "./PendingIncomeFromSale.vue?vue&type=script&lang=js"
import style0 from "./PendingIncomeFromSale.vue?vue&type=style&index=0&id=9ab51bda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab51bda",
  null
  
)

export default component.exports